export const GOOGLE_REFRESH_CERTIFICATE_SLUGS = [
  'google-data-analytics',
  'google-digital-marketing-ecommerce',
  'google-it-support',
  'google-project-management',
  'google-ux-design',
  'google-cybersecurity',
] as const;

export const GOOGLE_REFRESH_COURSE_SLUGS = [
  'prepare-for-cybersecurity-jobs',
  'applying-project-management',
  'ux-design-jobs',
  'satisfaction-guaranteed',
  'it-security',
  'google-data-analytics-capstone',
] as const;

export const shouldShowGoogleRefresh = (slug?: string) => {
  if (!slug) {
    return false;
  }

  return (
    GOOGLE_REFRESH_CERTIFICATE_SLUGS.includes(slug)
  );
};

export const shouldShowGoogleRefreshXdpAiSyllabus = (s12nSlug?: string, courseSlug?: string) => {
  if (!s12nSlug || !courseSlug) return false;

  return GOOGLE_REFRESH_COURSE_SLUGS.includes(courseSlug) && shouldShowGoogleRefresh(s12nSlug);
};

export default shouldShowGoogleRefresh;
